import { atom } from "recoil";
import { ConfirmPopupResult, ConfirmPopupVariant } from "../../types/popup";

export type ConfirmPopupConfig = {
  isVisible: boolean;
  headerTitle: string;
  message: string;
  discardButtonTitle: string;
  doNotSendButtonTitle: string;
  okButtonTitle: string;
  variant?: ConfirmPopupVariant;
  resolve: (value: ConfirmPopupResult) => void;
};

export const confirmPopupState = atom<ConfirmPopupConfig>({
  key: "confirmPopupState",
  default: {
    isVisible: false,
    headerTitle: "",
    message: "",
    discardButtonTitle: "Cancel",
    doNotSendButtonTitle: "Don't send",
    okButtonTitle: "Delete",
    variant: "default",
    resolve: () => {},
  },
});
